import script from "./NexaLogo.vue?vue&type=script&setup=true&lang=js"
export * from "./NexaLogo.vue?vue&type=script&setup=true&lang=js"

import "./NexaLogo.vue?vue&type=style&index=0&id=ea34e666&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea34e666"]])

export default __exports__